import {
  HYDRATED_QUERY_OPTIONS,
  unlimited2WeeksMaxDiscountAmountQuery,
} from '@/lib/page-queries';
import { pricingListQueryKey } from '@/lib/pricing-list';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from '../base-api';
import { getPricingList } from '../pricing.service';
import { CategoryDto } from '../types/pricing.type';

export const usePricingList = () => {
  return useQuery<ApiResponse<CategoryDto[]>>({
    queryKey: pricingListQueryKey(),
    queryFn: getPricingList,
    ...HYDRATED_QUERY_OPTIONS,
  });
};

export const useUnlimited2WeeksMaxDiscountAmount = () => {
  return useQuery<ApiResponse<number>>({
    ...unlimited2WeeksMaxDiscountAmountQuery(),
    ...HYDRATED_QUERY_OPTIONS,
  });
};
